<template>
  <div>
    <div class="bodyElement">
      <ElectionProbabilityBanner />
    </div>
    <div class="bodyElement header">
      <h1 class="bigTitle">{{ $t("FederalView.bigTitle1") }}</h1>
      <!--{{ currentView }} Poll Trends-->
      <div>{{ $t("FederalView.signature") }}</div>
    </div>
    <div class="bodyElement">
      <OpinionGraph currentView="FederalView" />
    </div>
    <div class="bodyElement header">
      <h1 class="bigTitle">{{ $t("FederalView.bigTitle2") }}</h1>
    </div>
    <div class="bodyElement">
      <ForecastGraph currentView="FederalView" />
    </div>
    <div class="bodyElement header">
      <h1 class="bigTitle">{{ "Election Probability" }}</h1>
    </div>
    <div class="bodyElement">
      <ElectionProbability />
    </div>
  </div>
</template>
<script>
import OpinionGraph from "../components/opinion/OpinionGraph.vue";
import ForecastGraph from "../components/forecast/ForecastGraph.vue";
import ElectionProbabilityBanner from "../components/election-probability/ElectionProbabilityBanner.vue";
import ElectionProbability from "../components/election-probability/ElectionProbability.vue";

export default {
  name: "FederalComponent",
  components: {
    OpinionGraph,
    ForecastGraph,
    ElectionProbabilityBanner,
    ElectionProbability,
  },
  data() {
    return {
      currentView: String,
    };
  },
};
</script>
<style src="../css/app.css"></style>
